<template>
    <div class="px-3 py-2">
        <b-sidebar aria-labelledby="sidebar-no-header-title" width="700px" no-header id="advanced_paid" backdrop style="direction:ltr" right title="اضافة مصروف دوري" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" :style="`direction:rtl`">
                    <div style="width:150px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span style="font-size:.8em;">{{$parent.lang.paid_in_advanced}}</span>
                    </div>
                    <div @click="hide" id="hideExp" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                        <span>{{$parent.lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="px-3 py-2" :style="`direction:`+$parent.lang.dir">
                    <v-form ref="apform">
                        <v-row>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.date}}</label>
                                <b-form-input class="inborder"
                                    :label="$parent.lang.date"
                                    v-model="receipt_date"
                                    type="date"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.paid_in_advanced_amount}}</label>
                                <b-form-input class="inborder"
                                    :label="$parent.lang.paid_in_advanced_amount"
                                    v-model="amount"
                                    :rules="fieldRules"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.installment_number}}</label>
                                <b-form-input class="inborder"
                                    :label="$parent.lang.installment_number"
                                    v-model="installment_number"
                                    :rules="fieldRules"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.installment_amount}}</label>
                                <b-form-input class="inborder"
                                    :label="$parent.lang.installment_amount"
                                    v-model="installment_amount"
                                    readonly
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.payment_type}}</label>
                                <b-input-group>
                                <b-form-select
                                    class="selborder"
                                    v-model="payment_type"
                                    :options="paytypes"
                                    :label="$parent.lang.payment_type"
                                    ></b-form-select>
                                <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                    <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.notes}}</label>
                                <b-form-textarea class="inborder"
                                    :label="$parent.lang.installment_amount"
                                    v-model="notes"
                                    ></b-form-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" variant="success" @click="addit()" class="ma-2" style="width:100px;">{{$parent.lang.add}}</b-button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
export default{
    data() {
        return {
            empid: 0,
            amount: '',
            installment_number: 1,
            payment_type: 1,
            retAcc: [],
            receipt_date: new Date().toISOString().substr(0, 10),
            notes: '',
            fieldRules: [
                v => v > 0 || this.$parent.lang.mor_than_zero
            ],
            paytypes: []
        }
    },
    computed: {
        installment_amount: function() {
            let t = 0;
            t = this.$RoundNum(parseFloat(this.amount) / parseFloat(this.installment_number));
            return t.toString() == "NaN" ? 0 : t;
        },
    },
    created(){
        this.getPyamentType();
    },
    methods: {
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[reic]',"all");
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.payTypeOp = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.paytypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                    this.retAcc = res.results.retAcc;
                }
            })
        },
        addit() {
            let vald = true;
            let message = '';
            if(this.amount == '' || this.amount <= 0){
                vald = false;
                message = this.$parent.lang.mor_than_zero;
            }
            if(this.retAcc[this.payment_type] < this.amount && this.$store.state.licenseType.allowPayInCredit) {
                vald = false;
                message = "رصيد الحساب لا يسمح يرجى اختيار طريقة دفع اخرى";
            }
            if(!vald){
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addAdvPaid");
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[amount]",this.amount);
            post.append("data[installment_number]",this.installment_number);
            post.append("data[empid]",this.empid);
            post.append("data[paytype]",this.payment_type);
            post.append("data[notes]",this.notes);
            post.append("data[receipt_date]",this.receipt_date);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.$snotify.error("تمت الاضافة بنجاح", 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                
                this.amount = '',
                this.installment_number = 1;   
                this.$parent.getEmployees();             
                document.getElementById('hideExp').click();

            })
        }
    },
}
</script>